var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.462 23.556C24.546 23.742 10.5 22.158 15.132 13.188C20.34 4.68002 28.404 18.954 30.462 23.556ZM30.462 23.556C28.326 20.364 19.938 6.59402 16.182 13.77C11.928 21.288 25.65 22.908 30.462 23.556Z",
    fill: "#FF4F40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.24 23.634C35.022 21.264 48.102 14.88 39.69 9.18602C31.758 3.12002 30.702 18.804 30.24 23.634ZM30.24 23.634C29.796 17.664 30.894 1.59002 40.38 8.20202C49.776 14.904 36.414 21.786 30.24 23.634Z",
    fill: "#FF4F40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.428 24.306H16.17C15.0499 24.306 14.142 25.214 14.142 26.334V50.772C14.142 51.892 15.0499 52.8 16.17 52.8H43.428C44.548 52.8 45.456 51.892 45.456 50.772V26.334C45.456 25.214 44.548 24.306 43.428 24.306Z",
    fill: "#FF989A",
    stroke: "#FF989A",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.634 24.306H26.976V52.8H32.634V24.306Z",
    fill: "#FF4F40",
    stroke: "#FF4F40",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.456 42.792V37.134H14.142V42.792H45.456Z",
    fill: "#FF4F40",
    stroke: "#FF4F40",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.206 22.014H13.398C12.997 22.014 12.672 22.3391 12.672 22.74V27.684C12.672 28.085 12.997 28.41 13.398 28.41H46.206C46.607 28.41 46.932 28.085 46.932 27.684V22.74C46.932 22.3391 46.607 22.014 46.206 22.014Z",
    fill: "#FF989A",
    stroke: "#FF989A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.518 26.784L47.472 26.928L49.836 23.748L50.922 27.558L54.672 28.818L51.39 31.026L51.348 34.986L48.228 32.544L44.448 33.732L45.81 30.012L43.518 26.784Z",
    fill: "#FEDC5D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.518 26.784C44.592 26.772 46.362 26.712 47.484 26.688L47.286 26.784C48.156 25.452 49.086 24.138 49.974 22.818C50.124 23.298 51.24 26.844 51.42 27.414L51.09 27.066L54.864 28.272L55.986 28.632L55.002 29.298L51.732 31.524L51.996 31.032C51.984 31.884 51.924 35.388 51.912 36.18L50.994 35.442L47.916 32.952L48.39 33.036C47.802 33.204 44.262 34.212 43.752 34.356C44.37 32.886 44.952 31.386 45.594 29.928L45.624 30.15C45.03 29.196 44.112 27.696 43.524 26.784H43.518ZM43.518 26.784C44.274 27.78 45.3 28.992 46.08 29.958C45.696 31.272 45.258 32.568 44.844 33.87L44.334 33.336L48.078 32.052L48.324 31.968L48.552 32.142L51.708 34.536L50.772 34.986L50.79 31.026V30.708L51.054 30.534L54.354 28.344L54.492 29.37L50.76 28.05L50.496 27.954L50.43 27.702L49.446 23.868L50.172 24C49.308 25.062 48.468 26.136 47.58 27.186C46.344 27.066 44.772 26.874 43.524 26.796L43.518 26.784Z",
    fill: "#FEDC5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.4eb68a1da894719fc0dba22a560fcaf2.svg";
export { ForwardRef as ReactComponent };